module.exports = __webpack_public_path__ + "static/georing-18468a18b927248166c604fbf231999d.png";